export default __webpack_public_path__ + "static/shutterstock_3-8e271245edad6bbf14d6a6f4e899b2e6.jpg";